import React,{useState} from 'react'
import GridAdditionalFields from './GridAdditionalFields'
import { getAdditionalFields, ProjectConfiguration,updateAdditionalFields } from 'utils/ProjectConfigurationUtil';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid'
import { useCanDoAction } from 'hooks/useCanDoAction';

const AdditionalFields = () => {
    const { selectedProject } = useAppContext() //Getting the App Context
    const columns = ProjectConfiguration.columnsAdditionalFields.filter(col => col.title !== "fieldId" )
    const title = "Additional Fields"
    const [updateDate, setUpdateDate] = useState(new Date());
    const canUpdate = useCanDoAction('ProjectConfig', 'update');
    const getFormPath = () => import('components/Shared/SkeletonForm');
     //Callback to update the Project Configuration Settings
      //TODO: Handle the user selection toggle 
      const receiveSettings = (evt, sectionSettingData,action) => {
          
        const data = JSON.parse(sectionSettingData)
        delete data['tableData']
        console.log(action)
        if(action === "Show") {
            data['show'] = evt.target.checked
            if(!evt.target.checked) {
                data['required'] = false
            }
        }else {
            data['required'] = evt.target.checked
            if(evt.target.checked) {
                data['show'] = evt.target.checked
            }
        }
       
        updateAdditionalFields(data, selectedProject).then(r => {
            setUpdateDate(new Date())
        })
    }

    const selection = { "display": canUpdate, "callback": receiveSettings, "tooltip": "", "btnText": "Update Additional Fields" }
    return (
        <div key={updateDate}>
            {
                selectedProject ?
                    <GridAdditionalFields columns={columns} title={title} getRecords={getAdditionalFields} selectedProject={selectedProject} paging={false}  component="ProjectConfig" formPath={getFormPath} selection={selection} /> : <SkeletonGrid title={title} />
            }
        </div>
    )

}

export default AdditionalFields
